import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocumentViewerComponent } from "./document-viewer.component";
import { NgxLoadingModule } from "ngx-loading";
import { PdfViewerModule } from "ng2-pdf-viewer";

@NgModule({
  declarations: [DocumentViewerComponent],
  imports: [CommonModule, NgxLoadingModule,PdfViewerModule],
  exports: [DocumentViewerComponent],
})
export class DocumentViewerModule {}
